import { render, staticRenderFns } from "./ChallengeOverview.vue?vue&type=template&id=a472c032&scoped=true&lang=pug&"
import script from "./ChallengeOverview.vue?vue&type=script&lang=js&"
export * from "./ChallengeOverview.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeOverview.vue?vue&type=style&index=0&id=a472c032&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a472c032",
  null
  
)

export default component.exports